/* eslint-disable arrow-parens */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { forwardRef, useCallback } from "react";

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";

import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import {
	Button,
	TextField,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	DialogContentText,
	Slide,
	Grid,
	Select,
	MenuItem
} from "@material-ui/core";

import EventIcon from "@material-ui/icons/Event";
import Close from "@material-ui/icons/Close";
import SendIcon from "@material-ui/icons/Send";
import { normalizeDateForSetValue } from "../../../../utils/commonFunctions/date";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const CustomBenefitEndDialog = ({
	dialogProps,
	handleTermReasonChange,
	handleDateChange,
	termValidation,
	handleClose,
	handleTermEmployment,
	terminationDate
}: any) => {
	const { openDialog, title, inputFields, actions, content } = dialogProps;
	// const normalizeDate = (dateString: string): Date => {
	// 	const parts = dateString.split("-");
	// 	return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
	// };
	// console.log("terminationDate Type:", typeof terminationDate, terminationDate);
	return (
		<div>
			<Dialog
				style={{ zIndex: 800 }}
				open={openDialog}
				onClose={handleClose}
				TransitionComponent={Transition as unknown as any}
				keepMounted
				aria-labelledby="form-dialog-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle id="form-dialog-title">
					<div className="custom-dialog-title">{title}</div>
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description">
						<div className="custom-term-dialog-content">{content}</div>
					</DialogContentText>
				</DialogContent>
				<DialogContent>
					{inputFields.map((textField: any, index: number) => {
						const { label, placeholder, name, type, value } = textField;

						return (
							<>
								<Grid container spacing={1} className=" pf-grid-container " key={index}>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<Grid container spacing={1} className="pf-label">
											<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
												<div className="pf-label-text ">{label}</div>
											</Grid>
											<Grid item xs={9} sm={9} md={8} lg={8} xl={8}>
												{type === "date" ? (
													<MuiPickersUtilsProvider utils={DateFnsUtils}>
														{/*  */}
														<KeyboardDatePicker
															className="from-date-input date-input"
															id="from-date-input"
															inputVariant="outlined"
															placeholder={placeholder}
															name={name}
															label={label}
															format="MM/dd/yyyy"
															error={false}
															// value={
															// 	terminationDate
															// 		? normalizeDateForSetValue(terminationDate)
															// 		: normalizeDateForSetValue(value)
															// }
															value={
																terminationDate
																	? terminationDate
																		? normalizeDateForSetValue(terminationDate)
																		: null
																	: value
																	? normalizeDateForSetValue(value)
																	: null
															}
															onChange={(_date) => handleDateChange(_date, name)}
															InputProps={{
																readOnly: true
															}}
															InputLabelProps={{
																shrink: true
															}}
															//style={{ width: "340px", borderRadius: 50 }}
															keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
															KeyboardButtonProps={{
																"aria-label": "change date"
															}}
															style={{
																// cursor: !isButtonSelected ? "not-allowed" : "pointer",
																pointerEvents: "unset",
																width: "350px",
																borderRadius: 50
															}}
															helperText={termValidation.termDetails["termination_date"]}
														/>
													</MuiPickersUtilsProvider>
												) : type === "textfield" ? (
													<TextField
														className="text-field"
														id="first-name-input"
														placeholder={placeholder}
														value={value}
														name={name}
														onChange={(event) => handleTermReasonChange(event)}
														variant="outlined"
														style={{
															pointerEvents: "unset",
															width: "340px",
															borderRadius: 50
														}}
														// helperText={termValidation.termDetails["term_reason"]}
													/>
												) : type === "select" ? (
													<>
														<Select
															id="text-align-options"
															name={name}
															value={value}
															onChange={(event) => handleTermReasonChange(event)}
															style={{
																//cursor: !isButtonSelected ? "not-allowed" : "pointer",
																pointerEvents: "unset",
																minWidth: 180,
																textAlign: "left",
																// zIndex: 10000,
																overflowY: "visible"
															}}
															MenuProps={{
																style: { zIndex: 35960 }
															}}
															inputProps={{ "aria-label": "Without label" }}
														>
															<MenuItem value="" disabled>
																Select Value
															</MenuItem>
															{textField?.options?.map((option: any) => (
																<MenuItem key={option} value={option}>
																	{option}
																</MenuItem>
															))}
														</Select>
														{termValidation &&
														termValidation?.termDetails["termination_reason"] ? (
															<div className="details">
																<span className="select-validation-text2">
																	{termValidation?.termDetails["termination_reason"]}
																</span>
															</div>
														) : null}
													</>
												) : null}
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</>
						);
					})}
				</DialogContent>
				<DialogActions className="custom-dialog-actions-button-container">
					{actions.map((action: any, index: number) => {
						const { label, callback, name } = action;

						return (
							<Button
								className={
									name === "cancels"
										? "custom-dialog-action-button-grey"
										: "custom-dialog-action-button-green"
								}
								variant="contained"
								key={index}
								// onClick={() => {
								// 	callback();
								// }}
								onClick={
									name === "submit"
										? handleTermEmployment
										: () => {
												callback();
										  }
								}
							>
								<span className="custom-dialog-action-button-label-with-icon">{label}</span>
								<span>
									{name === "submit" ? (
										<SendIcon className="custom-dialog-action-button-icon" />
									) : (
										<Close className="custom-dialog-action-button-icon" />
									)}
								</span>
							</Button>
						);
					})}
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default CustomBenefitEndDialog;
